// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: NsqqImYviY

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TweetButton from "../../TweetButton"; // plasmic-import: q0a14FKTL0L/component
import TwitterImages from "../../TwitterImages"; // plasmic-import: bz99yg430Et/component
import ItemDivider from "../../ItemDivider"; // plasmic-import: 0P_tUdN5Ni/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicTwitterItem.module.css"; // plasmic-import: NsqqImYviY/css

import IconarrowIosLeft2Icon from "./icons/PlasmicIcon__IconarrowIosLeft2"; // plasmic-import: Snqml0Rz7e/icon
import _27IconheartFillIcon from "./icons/PlasmicIcon___27IconheartFill"; // plasmic-import: kGUtMm7VKf/icon
import _27IconrepeatIcon from "./icons/PlasmicIcon___27Iconrepeat"; // plasmic-import: DXysMN739Bs/icon

createPlasmicElementProxy;

export type PlasmicTwitterItem__VariantMembers = {
  displayMode: "grid" | "list";
  composition:
    | "collapseImage"
    | "noImage"
    | "reply"
    | "collapsedThread"
    | "original"
    | "linkPreview";
  position: "top" | "middle" | "bottom";
};
export type PlasmicTwitterItem__VariantsArgs = {
  displayMode?: SingleChoiceArg<"grid" | "list">;
  composition?: SingleChoiceArg<
    | "collapseImage"
    | "noImage"
    | "reply"
    | "collapsedThread"
    | "original"
    | "linkPreview"
  >;
  position?: SingleChoiceArg<"top" | "middle" | "bottom">;
};
type VariantPropType = keyof PlasmicTwitterItem__VariantsArgs;
export const PlasmicTwitterItem__VariantProps = new Array<VariantPropType>(
  "displayMode",
  "composition",
  "position"
);

export type PlasmicTwitterItem__ArgsType = {
  twitterUserName?: React.ReactNode;
  twitterHandle?: React.ReactNode;
  text?: React.ReactNode;
  favourites?: React.ReactNode;
  retweets?: React.ReactNode;
  date?: React.ReactNode;
  time?: React.ReactNode;
  twitterImage?: React.ReactNode;
  uploadedImages?: any;
  linkPreview?: React.ReactNode;
};
type ArgPropType = keyof PlasmicTwitterItem__ArgsType;
export const PlasmicTwitterItem__ArgProps = new Array<ArgPropType>(
  "twitterUserName",
  "twitterHandle",
  "text",
  "favourites",
  "retweets",
  "date",
  "time",
  "twitterImage",
  "uploadedImages",
  "linkPreview"
);

export type PlasmicTwitterItem__OverridesType = {
  root?: p.Flex<"div">;
  card?: p.Flex<"div">;
  twitterUserContainer?: p.Flex<"div">;
  twitterUserImage?: p.Flex<typeof p.PlasmicImg>;
  twitterUserData?: p.Flex<"div">;
  twitterUserProfileLink?: p.Flex<"div">;
  tweetButton?: p.Flex<typeof TweetButton>;
  text?: p.Flex<"div">;
  showImage?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  twitterImages?: p.Flex<typeof TwitterImages>;
  imageContainer?: p.Flex<"div">;
  linkPreviewContainer?: p.Flex<"div">;
  metaData?: p.Flex<"div">;
  engagementData?: p.Flex<"div">;
  favouritesFrame?: p.Flex<"div">;
  heartIcon?: p.Flex<"svg">;
  favouritesContainer?: p.Flex<"div">;
  retweetFrame?: p.Flex<"div">;
  repeatIcon?: p.Flex<"svg">;
  retweetContainer?: p.Flex<"div">;
  datePublished?: p.Flex<"div">;
  dateContainer?: p.Flex<"div">;
  timeContainer?: p.Flex<"div">;
  itemDivider?: p.Flex<typeof ItemDivider>;
};

export interface DefaultTwitterItemProps {
  twitterUserName?: React.ReactNode;
  twitterHandle?: React.ReactNode;
  text?: React.ReactNode;
  favourites?: React.ReactNode;
  retweets?: React.ReactNode;
  date?: React.ReactNode;
  time?: React.ReactNode;
  twitterImage?: React.ReactNode;
  uploadedImages?: any;
  linkPreview?: React.ReactNode;
  displayMode?: SingleChoiceArg<"grid" | "list">;
  composition?: SingleChoiceArg<
    | "collapseImage"
    | "noImage"
    | "reply"
    | "collapsedThread"
    | "original"
    | "linkPreview"
  >;
  position?: SingleChoiceArg<"top" | "middle" | "bottom">;
  className?: string;
}

const $$ = {};

function PlasmicTwitterItem__RenderFunc(props: {
  variants: PlasmicTwitterItem__VariantsArgs;
  args: PlasmicTwitterItem__ArgsType;
  overrides: PlasmicTwitterItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          uploadedImages: [
            "https://cdn.pixabay.com/photo/2015/10/12/15/41/kayak-984566_1280.jpg",
            "https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_n.jpg",
            "https://www.fillmurray.com/200/300",
            "https://www.fillmurray.com/200/300",
            "https://www.fillmurray.com/200/300",
            "https://www.fillmurray.com/240/380"
          ]
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "composition",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.composition
      },
      {
        path: "position",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.position
      },
      {
        path: "displayMode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.displayMode
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootcomposition_collapsedThread]: hasVariant(
            $state,
            "composition",
            "collapsedThread"
          ),
          [sty.rootcomposition_linkPreview]: hasVariant(
            $state,
            "composition",
            "linkPreview"
          ),
          [sty.rootcomposition_original]: hasVariant(
            $state,
            "composition",
            "original"
          ),
          [sty.rootcomposition_reply]: hasVariant(
            $state,
            "composition",
            "reply"
          ),
          [sty.rootdisplayMode_list]: hasVariant($state, "displayMode", "list"),
          [sty.rootdisplayMode_list_global_theme_dark]:
            hasVariant($state, "displayMode", "list") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          )
        }
      )}
    >
      {(
        hasVariant($state, "composition", "reply")
          ? true
          : hasVariant(globalVariants, "theme", "dark")
          ? false
          : true
      ) ? (
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__e0YmX,
            {
              [sty.textcomposition_reply__e0YmXZd4Tc]: hasVariant(
                $state,
                "composition",
                "reply"
              ),
              [sty.textglobal_theme_dark__e0YmXoIz4X]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            }
          )}
        >
          <React.Fragment>
            <React.Fragment>{"repy by "}</React.Fragment>
            <span
              className={"plasmic_default__all plasmic_default__span"}
              style={{ color: "#4262DD" }}
            >
              {"@naval"}
            </span>
            <React.Fragment>{":"}</React.Fragment>
          </React.Fragment>
        </div>
      ) : null}
      <p.Stack
        as={"div"}
        data-plasmic-name={"card"}
        data-plasmic-override={overrides.card}
        hasGap={true}
        className={classNames(projectcss.all, sty.card, {
          [sty.cardcomposition_collapseImage]: hasVariant(
            $state,
            "composition",
            "collapseImage"
          ),
          [sty.cardcomposition_collapsedThread]: hasVariant(
            $state,
            "composition",
            "collapsedThread"
          ),
          [sty.cardcomposition_linkPreview]: hasVariant(
            $state,
            "composition",
            "linkPreview"
          ),
          [sty.cardcomposition_original]: hasVariant(
            $state,
            "composition",
            "original"
          ),
          [sty.cardcomposition_reply]: hasVariant(
            $state,
            "composition",
            "reply"
          ),
          [sty.carddisplayMode_list]: hasVariant($state, "displayMode", "list"),
          [sty.carddisplayMode_list_global_theme_dark]:
            hasVariant($state, "displayMode", "list") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.cardglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.cardposition_bottom]: hasVariant($state, "position", "bottom"),
          [sty.cardposition_middle]: hasVariant($state, "position", "middle"),
          [sty.cardposition_top]: hasVariant($state, "position", "top")
        })}
      >
        <p.Stack
          as={"div"}
          data-plasmic-name={"twitterUserContainer"}
          data-plasmic-override={overrides.twitterUserContainer}
          hasGap={true}
          className={classNames(projectcss.all, sty.twitterUserContainer, {
            [sty.twitterUserContainercomposition_collapseImage]: hasVariant(
              $state,
              "composition",
              "collapseImage"
            ),
            [sty.twitterUserContainercomposition_reply]: hasVariant(
              $state,
              "composition",
              "reply"
            ),
            [sty.twitterUserContainerdisplayMode_list]: hasVariant(
              $state,
              "displayMode",
              "list"
            )
          })}
        >
          <p.PlasmicImg
            data-plasmic-name={"twitterUserImage"}
            data-plasmic-override={overrides.twitterUserImage}
            alt={""}
            className={classNames(sty.twitterUserImage, {
              [sty.twitterUserImagedisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              )
            })}
            displayHeight={"1.87em"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"1.87em"}
            loader={"plasmic"}
            src={{
              src: "https://site-assets.plasmic.app/ee608996e6a63ad5d746966ed37e118b.svg",
              fullWidth: 30,
              fullHeight: 30,
              aspectRatio: 1
            }}
          />

          <div
            data-plasmic-name={"twitterUserData"}
            data-plasmic-override={overrides.twitterUserData}
            className={classNames(projectcss.all, sty.twitterUserData, {
              [sty.twitterUserDatacomposition_collapseImage]: hasVariant(
                $state,
                "composition",
                "collapseImage"
              ),
              [sty.twitterUserDatacomposition_reply]: hasVariant(
                $state,
                "composition",
                "reply"
              ),
              [sty.twitterUserDatadisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              )
            })}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox___29UrG, {
                [sty.freeBoxcomposition_collapseImage___29UrGmeBUw]: hasVariant(
                  $state,
                  "composition",
                  "collapseImage"
                ),
                [sty.freeBoxdisplayMode_list___29UrGHmOQw]: hasVariant(
                  $state,
                  "displayMode",
                  "list"
                ),
                [sty.freeBoxglobal_theme_dark___29UrGoIz4X]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vQy2Q,
                      {
                        [sty.textdisplayMode_list__vQy2QHmOQw]: hasVariant(
                          $state,
                          "displayMode",
                          "list"
                        )
                      }
                    )}
                  >
                    {"Naval Ravikant Bot"}
                  </div>
                ),
                value: args.twitterUserName,
                className: classNames(sty.slotTargetTwitterUserName, {
                  [sty.slotTargetTwitterUserNamecomposition_collapseImage]:
                    hasVariant($state, "composition", "collapseImage"),
                  [sty.slotTargetTwitterUserNamedisplayMode_list]: hasVariant(
                    $state,
                    "displayMode",
                    "list"
                  ),
                  [sty.slotTargetTwitterUserNameglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })
              })}
            </div>
            <div
              data-plasmic-name={"twitterUserProfileLink"}
              data-plasmic-override={overrides.twitterUserProfileLink}
              className={classNames(
                projectcss.all,
                sty.twitterUserProfileLink,
                {
                  [sty.twitterUserProfileLinkcomposition_collapseImage]:
                    hasVariant($state, "composition", "collapseImage"),
                  [sty.twitterUserProfileLinkdisplayMode_list]: hasVariant(
                    $state,
                    "displayMode",
                    "list"
                  ),
                  [sty.twitterUserProfileLinkdisplayMode_list_global_theme_dark]:
                    hasVariant($state, "displayMode", "list") &&
                    hasVariant(globalVariants, "theme", "dark"),
                  [sty.twitterUserProfileLinkglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                }
              )}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__iuNxw,
                      {
                        [sty.textdisplayMode_list__iuNxwHmOQw]: hasVariant(
                          $state,
                          "displayMode",
                          "list"
                        )
                      }
                    )}
                  >
                    {"@NavalBot"}
                  </div>
                ),
                value: args.twitterHandle,
                className: classNames(sty.slotTargetTwitterHandle, {
                  [sty.slotTargetTwitterHandlecomposition_collapseImage]:
                    hasVariant($state, "composition", "collapseImage"),
                  [sty.slotTargetTwitterHandledisplayMode_list]: hasVariant(
                    $state,
                    "displayMode",
                    "list"
                  ),
                  [sty.slotTargetTwitterHandleglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })
              })}
            </div>
          </div>
          <TweetButton
            data-plasmic-name={"tweetButton"}
            data-plasmic-override={overrides.tweetButton}
            className={classNames("__wab_instance", sty.tweetButton, {
              [sty.tweetButtoncomposition_collapseImage]: hasVariant(
                $state,
                "composition",
                "collapseImage"
              )
            })}
          />
        </p.Stack>
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(projectcss.all, sty.text, {
            [sty.textcomposition_collapseImage]: hasVariant(
              $state,
              "composition",
              "collapseImage"
            ),
            [sty.textglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            )
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents:
              "Your goal in life is to find out the people who need you the most, to find out the business that needs you the most, to find the project and the art that needs you the most. There is something out there just for you.\u201d",
            value: args.text,
            className: classNames(sty.slotTargetText, {
              [sty.slotTargetTextcomposition_collapseImage]: hasVariant(
                $state,
                "composition",
                "collapseImage"
              ),
              [sty.slotTargetTextdisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              ),
              [sty.slotTargetTextglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })
          })}
        </div>
        {(hasVariant($state, "composition", "collapseImage") ? true : false) ? (
          <div
            data-plasmic-name={"showImage"}
            data-plasmic-override={overrides.showImage}
            className={classNames(projectcss.all, sty.showImage, {
              [sty.showImagecomposition_collapseImage]: hasVariant(
                $state,
                "composition",
                "collapseImage"
              )
            })}
          >
            {(
              hasVariant($state, "composition", "collapseImage") ? true : false
            ) ? (
              <IconarrowIosLeft2Icon
                data-plasmic-name={"svg"}
                data-plasmic-override={overrides.svg}
                className={classNames(projectcss.all, sty.svg, {
                  [sty.svgcomposition_collapseImage]: hasVariant(
                    $state,
                    "composition",
                    "collapseImage"
                  )
                })}
                role={"img"}
              />
            ) : null}
            {(
              hasVariant($state, "composition", "collapseImage") ? true : false
            ) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__we3Dn,
                  {
                    [sty.textcomposition_collapseImage__we3DNmeBUw]: hasVariant(
                      $state,
                      "composition",
                      "collapseImage"
                    )
                  }
                )}
              >
                {hasVariant($state, "composition", "collapseImage")
                  ? "show image "
                  : "Enter some text"}
              </div>
            ) : null}
          </div>
        ) : null}
        <TwitterImages
          data-plasmic-name={"twitterImages"}
          data-plasmic-override={overrides.twitterImages}
          className={classNames("__wab_instance", sty.twitterImages, {
            [sty.twitterImagescomposition_linkPreview]: hasVariant(
              $state,
              "composition",
              "linkPreview"
            ),
            [sty.twitterImagescomposition_original]: hasVariant(
              $state,
              "composition",
              "original"
            ),
            [sty.twitterImagesdisplayMode_list]: hasVariant(
              $state,
              "displayMode",
              "list"
            ),
            [sty.twitterImagesdisplayMode_list_global_theme_dark]:
              hasVariant($state, "displayMode", "list") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.twitterImagesglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            )
          })}
          imageCount={
            hasVariant($state, "displayMode", "list") ? "many" : undefined
          }
          size={hasVariant($state, "displayMode", "list") ? "list" : undefined}
        />

        {(
          hasVariant($state, "composition", "noImage")
            ? false
            : hasVariant($state, "composition", "collapseImage")
            ? false
            : hasVariant($state, "displayMode", "list")
            ? true
            : true
        ) ? (
          <div
            data-plasmic-name={"imageContainer"}
            data-plasmic-override={overrides.imageContainer}
            className={classNames(projectcss.all, sty.imageContainer, {
              [sty.imageContainercomposition_collapseImage]: hasVariant(
                $state,
                "composition",
                "collapseImage"
              ),
              [sty.imageContainercomposition_noImage]: hasVariant(
                $state,
                "composition",
                "noImage"
              ),
              [sty.imageContainerdisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              ),
              [sty.imageContainerglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            {p.renderPlasmicSlot({
              defaultContents: (
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__pBIcY)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/e7c916aac911437acfc1cde858797fce.jpg",
                    fullWidth: 422,
                    fullHeight: 310
                  }}
                />
              ),

              value: args.twitterImage
            })}
          </div>
        ) : null}
        <div
          data-plasmic-name={"linkPreviewContainer"}
          data-plasmic-override={overrides.linkPreviewContainer}
          className={classNames(projectcss.all, sty.linkPreviewContainer, {
            [sty.linkPreviewContainercomposition_linkPreview]: hasVariant(
              $state,
              "composition",
              "linkPreview"
            )
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: "",
            value: args.linkPreview
          })}
        </div>
        <div
          data-plasmic-name={"metaData"}
          data-plasmic-override={overrides.metaData}
          className={classNames(projectcss.all, sty.metaData, {
            [sty.metaDatacomposition_original]: hasVariant(
              $state,
              "composition",
              "original"
            ),
            [sty.metaDatadisplayMode_list]: hasVariant(
              $state,
              "displayMode",
              "list"
            ),
            [sty.metaDataglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            )
          })}
        >
          <p.Stack
            as={"div"}
            data-plasmic-name={"engagementData"}
            data-plasmic-override={overrides.engagementData}
            hasGap={true}
            className={classNames(projectcss.all, sty.engagementData, {
              [sty.engagementDataglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"favouritesFrame"}
              data-plasmic-override={overrides.favouritesFrame}
              hasGap={true}
              className={classNames(projectcss.all, sty.favouritesFrame, {
                [sty.favouritesFramecomposition_collapseImage]: hasVariant(
                  $state,
                  "composition",
                  "collapseImage"
                ),
                [sty.favouritesFrameglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              <_27IconheartFillIcon
                data-plasmic-name={"heartIcon"}
                data-plasmic-override={overrides.heartIcon}
                className={classNames(projectcss.all, sty.heartIcon, {
                  [sty.heartIconcomposition_collapseImage]: hasVariant(
                    $state,
                    "composition",
                    "collapseImage"
                  ),
                  [sty.heartIconglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })}
                role={"img"}
              />

              <div
                data-plasmic-name={"favouritesContainer"}
                data-plasmic-override={overrides.favouritesContainer}
                className={classNames(projectcss.all, sty.favouritesContainer, {
                  [sty.favouritesContainercomposition_collapseImage]:
                    hasVariant($state, "composition", "collapseImage"),
                  [sty.favouritesContainerglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })}
              >
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___7QAPw
                      )}
                    >
                      {"1.7k"}
                    </div>
                  ),
                  value: args.favourites,
                  className: classNames(sty.slotTargetFavourites, {
                    [sty.slotTargetFavouritescomposition_collapseImage]:
                      hasVariant($state, "composition", "collapseImage"),
                    [sty.slotTargetFavouritesglobal_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    )
                  })
                })}
              </div>
            </p.Stack>
            <p.Stack
              as={"div"}
              data-plasmic-name={"retweetFrame"}
              data-plasmic-override={overrides.retweetFrame}
              hasGap={true}
              className={classNames(projectcss.all, sty.retweetFrame, {
                [sty.retweetFramecomposition_collapseImage]: hasVariant(
                  $state,
                  "composition",
                  "collapseImage"
                ),
                [sty.retweetFrameglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              <_27IconrepeatIcon
                data-plasmic-name={"repeatIcon"}
                data-plasmic-override={overrides.repeatIcon}
                className={classNames(projectcss.all, sty.repeatIcon, {
                  [sty.repeatIconcomposition_collapseImage]: hasVariant(
                    $state,
                    "composition",
                    "collapseImage"
                  ),
                  [sty.repeatIconglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })}
                role={"img"}
              />

              <div
                data-plasmic-name={"retweetContainer"}
                data-plasmic-override={overrides.retweetContainer}
                className={classNames(projectcss.all, sty.retweetContainer, {
                  [sty.retweetContainercomposition_collapseImage]: hasVariant(
                    $state,
                    "composition",
                    "collapseImage"
                  ),
                  [sty.retweetContainerglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })}
              >
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__c57Hq
                      )}
                    >
                      {"372"}
                    </div>
                  ),
                  value: args.retweets,
                  className: classNames(sty.slotTargetRetweets, {
                    [sty.slotTargetRetweetscomposition_collapseImage]:
                      hasVariant($state, "composition", "collapseImage"),
                    [sty.slotTargetRetweetsglobal_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    )
                  })
                })}
              </div>
            </p.Stack>
          </p.Stack>
          <p.Stack
            as={"div"}
            data-plasmic-name={"datePublished"}
            data-plasmic-override={overrides.datePublished}
            hasGap={true}
            className={classNames(projectcss.all, sty.datePublished, {
              [sty.datePublishedcomposition_collapseImage]: hasVariant(
                $state,
                "composition",
                "collapseImage"
              ),
              [sty.datePublishedglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <div
              data-plasmic-name={"dateContainer"}
              data-plasmic-override={overrides.dateContainer}
              className={classNames(projectcss.all, sty.dateContainer, {
                [sty.dateContainercomposition_collapseImage]: hasVariant(
                  $state,
                  "composition",
                  "collapseImage"
                ),
                [sty.dateContainerglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___93PQf
                    )}
                  >
                    {"Mar 14"}
                  </div>
                ),
                value: args.date,
                className: classNames(sty.slotTargetDate, {
                  [sty.slotTargetDatecomposition_collapseImage]: hasVariant(
                    $state,
                    "composition",
                    "collapseImage"
                  ),
                  [sty.slotTargetDateglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })
              })}
            </div>
            <div
              data-plasmic-name={"timeContainer"}
              data-plasmic-override={overrides.timeContainer}
              className={classNames(projectcss.all, sty.timeContainer, {
                [sty.timeContainercomposition_collapseImage]: hasVariant(
                  $state,
                  "composition",
                  "collapseImage"
                ),
                [sty.timeContainerglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__hZcOw
                    )}
                  >
                    {"8:00 PM"}
                  </div>
                ),
                value: args.time,
                className: classNames(sty.slotTargetTime, {
                  [sty.slotTargetTimecomposition_collapseImage]: hasVariant(
                    $state,
                    "composition",
                    "collapseImage"
                  ),
                  [sty.slotTargetTimeglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                })
              })}
            </div>
          </p.Stack>
        </div>
      </p.Stack>
      <ItemDivider
        data-plasmic-name={"itemDivider"}
        data-plasmic-override={overrides.itemDivider}
        className={classNames("__wab_instance", sty.itemDivider, {
          [sty.itemDividerdisplayMode_list]: hasVariant(
            $state,
            "displayMode",
            "list"
          ),
          [sty.itemDividerdisplayMode_list_global_theme_dark]:
            hasVariant($state, "displayMode", "list") &&
            hasVariant(globalVariants, "theme", "dark")
        })}
        color={
          hasVariant($state, "displayMode", "list") ? "darkGrey" : undefined
        }
      />

      {(
        hasVariant($state, "composition", "original")
          ? false
          : hasVariant($state, "composition", "collapsedThread")
          ? true
          : hasVariant(globalVariants, "theme", "dark")
          ? false
          : true
      ) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__ow1Pp, {
            [sty.freeBoxcomposition_collapsedThread__ow1PpLWvQ]: hasVariant(
              $state,
              "composition",
              "collapsedThread"
            ),
            [sty.freeBoxcomposition_original__ow1PpqcqUc]: hasVariant(
              $state,
              "composition",
              "original"
            ),
            [sty.freeBoxglobal_theme_dark__ow1PpOIz4X]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__hu7Vu,
              {
                [sty.textcomposition_collapsedThread__hu7VuLWvQ]: hasVariant(
                  $state,
                  "composition",
                  "collapsedThread"
                ),
                [sty.textcomposition_original__hu7VuqcqUc]: hasVariant(
                  $state,
                  "composition",
                  "original"
                ),
                [sty.textglobal_theme_dark__hu7VuOIz4X]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              }
            )}
          >
            {hasVariant(globalVariants, "theme", "dark")
              ? "expand Thread"
              : "expand Thread"}
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "card",
    "twitterUserContainer",
    "twitterUserImage",
    "twitterUserData",
    "twitterUserProfileLink",
    "tweetButton",
    "text",
    "showImage",
    "svg",
    "twitterImages",
    "imageContainer",
    "linkPreviewContainer",
    "metaData",
    "engagementData",
    "favouritesFrame",
    "heartIcon",
    "favouritesContainer",
    "retweetFrame",
    "repeatIcon",
    "retweetContainer",
    "datePublished",
    "dateContainer",
    "timeContainer",
    "itemDivider"
  ],
  card: [
    "card",
    "twitterUserContainer",
    "twitterUserImage",
    "twitterUserData",
    "twitterUserProfileLink",
    "tweetButton",
    "text",
    "showImage",
    "svg",
    "twitterImages",
    "imageContainer",
    "linkPreviewContainer",
    "metaData",
    "engagementData",
    "favouritesFrame",
    "heartIcon",
    "favouritesContainer",
    "retweetFrame",
    "repeatIcon",
    "retweetContainer",
    "datePublished",
    "dateContainer",
    "timeContainer"
  ],
  twitterUserContainer: [
    "twitterUserContainer",
    "twitterUserImage",
    "twitterUserData",
    "twitterUserProfileLink",
    "tweetButton"
  ],
  twitterUserImage: ["twitterUserImage"],
  twitterUserData: ["twitterUserData", "twitterUserProfileLink"],
  twitterUserProfileLink: ["twitterUserProfileLink"],
  tweetButton: ["tweetButton"],
  text: ["text"],
  showImage: ["showImage", "svg"],
  svg: ["svg"],
  twitterImages: ["twitterImages"],
  imageContainer: ["imageContainer"],
  linkPreviewContainer: ["linkPreviewContainer"],
  metaData: [
    "metaData",
    "engagementData",
    "favouritesFrame",
    "heartIcon",
    "favouritesContainer",
    "retweetFrame",
    "repeatIcon",
    "retweetContainer",
    "datePublished",
    "dateContainer",
    "timeContainer"
  ],
  engagementData: [
    "engagementData",
    "favouritesFrame",
    "heartIcon",
    "favouritesContainer",
    "retweetFrame",
    "repeatIcon",
    "retweetContainer"
  ],
  favouritesFrame: ["favouritesFrame", "heartIcon", "favouritesContainer"],
  heartIcon: ["heartIcon"],
  favouritesContainer: ["favouritesContainer"],
  retweetFrame: ["retweetFrame", "repeatIcon", "retweetContainer"],
  repeatIcon: ["repeatIcon"],
  retweetContainer: ["retweetContainer"],
  datePublished: ["datePublished", "dateContainer", "timeContainer"],
  dateContainer: ["dateContainer"],
  timeContainer: ["timeContainer"],
  itemDivider: ["itemDivider"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  card: "div";
  twitterUserContainer: "div";
  twitterUserImage: typeof p.PlasmicImg;
  twitterUserData: "div";
  twitterUserProfileLink: "div";
  tweetButton: typeof TweetButton;
  text: "div";
  showImage: "div";
  svg: "svg";
  twitterImages: typeof TwitterImages;
  imageContainer: "div";
  linkPreviewContainer: "div";
  metaData: "div";
  engagementData: "div";
  favouritesFrame: "div";
  heartIcon: "svg";
  favouritesContainer: "div";
  retweetFrame: "div";
  repeatIcon: "svg";
  retweetContainer: "div";
  datePublished: "div";
  dateContainer: "div";
  timeContainer: "div";
  itemDivider: typeof ItemDivider;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTwitterItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTwitterItem__VariantsArgs;
    args?: PlasmicTwitterItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTwitterItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicTwitterItem__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTwitterItem__ArgProps,
          internalVariantPropNames: PlasmicTwitterItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTwitterItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTwitterItem";
  } else {
    func.displayName = `PlasmicTwitterItem.${nodeName}`;
  }
  return func;
}

export const PlasmicTwitterItem = Object.assign(
  // Top-level PlasmicTwitterItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    card: makeNodeComponent("card"),
    twitterUserContainer: makeNodeComponent("twitterUserContainer"),
    twitterUserImage: makeNodeComponent("twitterUserImage"),
    twitterUserData: makeNodeComponent("twitterUserData"),
    twitterUserProfileLink: makeNodeComponent("twitterUserProfileLink"),
    tweetButton: makeNodeComponent("tweetButton"),
    text: makeNodeComponent("text"),
    showImage: makeNodeComponent("showImage"),
    svg: makeNodeComponent("svg"),
    twitterImages: makeNodeComponent("twitterImages"),
    imageContainer: makeNodeComponent("imageContainer"),
    linkPreviewContainer: makeNodeComponent("linkPreviewContainer"),
    metaData: makeNodeComponent("metaData"),
    engagementData: makeNodeComponent("engagementData"),
    favouritesFrame: makeNodeComponent("favouritesFrame"),
    heartIcon: makeNodeComponent("heartIcon"),
    favouritesContainer: makeNodeComponent("favouritesContainer"),
    retweetFrame: makeNodeComponent("retweetFrame"),
    repeatIcon: makeNodeComponent("repeatIcon"),
    retweetContainer: makeNodeComponent("retweetContainer"),
    datePublished: makeNodeComponent("datePublished"),
    dateContainer: makeNodeComponent("dateContainer"),
    timeContainer: makeNodeComponent("timeContainer"),
    itemDivider: makeNodeComponent("itemDivider"),

    // Metadata about props expected for PlasmicTwitterItem
    internalVariantProps: PlasmicTwitterItem__VariantProps,
    internalArgProps: PlasmicTwitterItem__ArgProps
  }
);

export default PlasmicTwitterItem;
/* prettier-ignore-end */
